<template>
  <div class="body">
    <TopNav :showDetail="!showDetail"></TopNav>
    <Detail :fixed="showDetail" v-show="showDetail"></Detail>
    <SectionHot></SectionHot>
    <Product></Product>
    <Free></Free>
    <Process></Process>
    <Service></Service>
    <Parnter></Parnter>
    <Set></Set>
    <Footer></Footer>
    <Feedback></Feedback>
    <!-- <Feedback></Feedback> -->
  </div>
</template>

<script>
import TopNav from "./TopNav"
import Detail from "./Detail"
import Carousel from "./Carousel"
import SectionHot from "./SectionHot"
import Product from "./Product"
import Free from "./Free"
import Process from "./Process"
import Service from "./Service"
import Parnter from "./Partner"
import Footer from "./Footer"
import Set from "./Set"
import Feedback from "./Feedback"

export default {
  components: {
    Detail,
    TopNav,
    Carousel,
    SectionHot,
    Product,
    Free,
    Process,
    Service,
    Parnter,
    Footer,
    Set,
    Feedback,
  },
  data() {
    return {
      showDetail: false,
    }
  },
  methods: {},
  mounted() {
    
    let _self = this
    $(window).scroll(function() {
      var scrollTop = $(window).scrollTop()
      if (scrollTop > 100) {
        _self.showDetail = true
      } else {
        _self.showDetail = false
      }
    })
  },
}
</script>

<style>
@import "../../assets/css/default/top-nav.css";
@import "../../assets/css/default/main.css";
</style>
